import script from "./AgencyGrowthRegister.vue?vue&type=script&setup=true&lang=js"
export * from "./AgencyGrowthRegister.vue?vue&type=script&setup=true&lang=js"

import "./AgencyGrowthRegister.vue?vue&type=style&index=0&id=4d9429ce&lang=scss&scoped=true"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d9429ce"]])

export default __exports__